import { useState } from 'react';

interface Props {
    text: string;
    className?: string;
}

export const ExpandableTextPanel = ({ text, className }: Props) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={className || ''}>
            <div className={`u-mb16 ${expanded ? '' : 'collapsed-text-panel'}`}>{text}</div>
            <button type="button" className="button button--link" onClick={(): void => setExpanded(!expanded)}>
                {expanded ? 'Skjul' : 'Les mer'}
            </button>
        </div>
    );
};
